// extracted by mini-css-extract-plugin
export var buttons = "bD_cp";
export var left = "bD_bL";
export var media = "bD_gB";
export var right = "bD_bQ";
export var section = "bD_j";
export var selected = "bD_bg";
export var signature = "bD_gz";
export var testimonial = "bD_gy";
export var text = "bD_cl";
export var textContainer = "bD_bV";
export var video = "bD_gC";